// 점수 미부여(null)는 0점과 구분해 "-" 로 표시한다. 이행평가 피드백 업로드(VMD-389)는 별점 없이 평가완료로만 표시하므로
// 0 으로 보이면 매장이 0점을 받은 것으로 읽는다.
export const formatScore = (score: number | null | undefined): string => (score == null ? "-" : String(score));
